import { clamp } from 'lodash';

export const layout = {
  viewport: {
    ratio: {
      width: 0,
      height: 0,
    },
    clampedRatio: {
      width: 0,
      height: 0,
    },
    reference: {
      width: 1920,
      height: 1080,
    },
    actual: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
  },
  calculateRatio() {
    layout.viewport.actual.width = window.innerWidth;
    layout.viewport.actual.height = window.innerHeight;
    layout.viewport.ratio.width = layout.viewport.actual.width / layout.viewport.reference.width;
    layout.viewport.ratio.height = layout.viewport.actual.height / layout.viewport.reference.height;
    layout.viewport.clampedRatio.width = clamp(layout.viewport.ratio.width, 0.25, 1.5);
    layout.viewport.clampedRatio.height = clamp(layout.viewport.ratio.height, 0.25, 1.5);
  },
  get padding() {
    return window.innerWidth > 720 ? {
      top: 60,
      bottom: 0,
      left: 50,
      right: 50,
    } : {
      top: 60,
      bottom: 0,
      left: 25,
      right: 25,
    };
  },
  sectionsPadding: 380,
};
